
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__search__",
      function () {
        return require("private-next-pages/__search__.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__search__"])
      });
    }
  